import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=0257db09&scoped=true&"
import script from "./navItem.vue?vue&type=script&lang=js&"
export * from "./navItem.vue?vue&type=script&lang=js&"
import style0 from "./navItem.vue?vue&type=style&index=0&id=0257db09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257db09",
  null
  
)

export default component.exports